import { OnInit, Component, Output, EventEmitter, Input } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { InvoiceService } from 'src/app/services/invoice.service';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { HttpAlertService } from 'src/app/services/http-alert.service';
import { TranslateService } from '@ngx-translate/core';
import { InvoiceDetails } from 'src/app/intefaces/Invoiced-details.interface';
import { GusService } from 'src/app/services/gus.service';


@Component({
    selector: 'invoice-details-list',
    templateUrl: './invoice-details-list.component.html',
    styleUrls: ['./invoice-details-list.component.scss'],
    providers: [ConfirmationService]
})
export class InvoiceDetailsListComponent implements OnInit {

    invoiceDetails: InvoiceDetails[] = [];
    display: boolean = false;
    isEditing: boolean = false;
    invoiceDetailsForm: FormGroup;
    isDataReady: boolean = false;
    @Output() onChangeInvoice = new EventEmitter<InvoiceDetails>();
    @Output() invoicesList = new EventEmitter<InvoiceDetails[]>();

    @Input() selectedInvoice: InvoiceDetails = null;

    gusDialogVisible = false;
    gusTaxNumber: string = '';
    isNipValid = true;
    gusDataLoading = false;
    public _readonly: boolean = false;
    public typesInvoice;
    recipientFormVisible = false;
    recipientForm: FormGroup;
    isMobile: boolean;

    countries = [
      { label:'Austria', value: 'AT' },
      { label:'Belgium', value: 'BE' },
      { label:'Bulgaria', value: 'BG' },
      { label:'Cyprus', value: 'CY' },
      { label:'Czech Republic', value: 'CZ' },
      { label:'Germany', value: 'DE' },
      { label:'Denmark', value: 'DK' },
      { label:'Estonia', value: 'EE' },
      { label:'Greece', value: 'EL' },
      { label:'Spain', value: 'ES' },
      { label:'Finland', value: 'FI' },
      { label:'France', value: 'FR' },
      { label:'United Kingdom', value: 'GB' },
      { label:'Croatia', value: 'HR' },
      { label:'Hungary', value: 'HU' },
      { label:'Ireland', value: 'IE' },
      { label:'Italy', value: 'IT' },
      { label:'Lithuania', value: 'LT' },
      { label:'Luxembourg', value: 'LU' },
      { label:'Latvia', value: 'LV' },
      { label:'Malta', value: 'MT' },
      { label:'Polska', value: 'PL' },
      { label:'Portugal', value: 'PT' },
      { label:'Romania', value: 'RO' },
      { label:'Sweden', value: 'SE' },
      { label:'Slovenia', value: 'SI' },
      { label:'Slovakia', value: 'SK' },
    ];

    @Input() set readonly(value: boolean) {
        this._readonly = value;
        this.filterCheckedInvoceData();
    }

    constructor(
        private confirmationService: ConfirmationService,
        private invoiceService: InvoiceService,
        private formBuilder: FormBuilder,
        private alertService: HttpAlertService,
        private translate: TranslateService,
        private gusService: GusService) {
           this.typesInvoice = [
            { label: this.translate.instant("private_person"), value: 2 },
            { label: this.translate.instant("company"), value: 1 }
           ];

        if (window.innerWidth <= 1025) {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
    }

    ngOnInit(): void {
        this.initForm();
        this.fetchData();

    }

    private fetchData() {
        this.invoiceService.getInvoiceDetails().subscribe((response: any) => {
            this.invoiceDetails = response.data.invoice_details;
            this.isDataReady = true;
            this.invoicesList.emit(this.invoiceDetails);
        });
    }

    private filterCheckedInvoceData() {
        if(this._readonly && this.selectedInvoice) {
            this.invoiceDetails = this.invoiceDetails.filter(data => data.id == this.selectedInvoice.id);
        } else {
            this.fetchData();
        }
    }

    public initForm(): void {
        this.invoiceDetailsForm = this.formBuilder.group({
            id: [''],
            name: ['', Validators.required],
            surname: ['', Validators.required],
            tax_number: ['', Validators.required],
            country: ['', Validators.required],
            city: ['', Validators.required],
            street: ['', Validators.required],
            street_number: ['', Validators.required],
            apartment_number: [''],
            postal_code: ['', Validators.required],
            is_gus_data: [false],
            invoice_type: ['', Validators.required ],
        });

        this.recipientForm = this.formBuilder.group({
          recipient_name: ['', Validators.required],
          recipient_city: ['', Validators.required],
          recipient_street: ['', Validators.required],
          recipient_street_number: ['', Validators.required],
          recipient_postal_code: ['', Validators.required],
        });
 
       
    }

    public onInvoiceTypeChange(event) {
      if (event.value == 2) {
        this.invoiceDetailsForm.controls['tax_number'].disable();
        this.invoiceDetailsForm.controls['tax_number'].setValue('');
        this.invoiceDetailsForm.controls['tax_number'].clearValidators();
        this.invoiceDetailsForm.controls['tax_number'].updateValueAndValidity();
        this.invoiceDetailsForm.controls['surname'].enable();
        this.invoiceDetailsForm.controls["surname"].setValidators(Validators.required);
        this.invoiceDetailsForm.controls["surname"].updateValueAndValidity();
      } else {
        this.invoiceDetailsForm.controls['tax_number'].enable();
        this.invoiceDetailsForm.controls["tax_number"].setValidators(Validators.required);
        this.invoiceDetailsForm.controls["tax_number"].updateValueAndValidity();
        this.invoiceDetailsForm.controls['surname'].disable();
        this.invoiceDetailsForm.controls['surname'].setValue('');
        this.invoiceDetailsForm.controls['surname'].clearValidators();
        this.invoiceDetailsForm.controls['surname'].updateValueAndValidity();
      }
    }

    public onRemoveItem(id: number): void {
        this.translate.get(['invoice_details_delete_confirm']).subscribe(t => {
            this.confirmationService.confirm({
                message: t.invoice_details_delete_confirm,
                accept: () => {
                    this.doDeleteDetails(id);
                }
            });
        });
    }

    public doDeleteDetails(id: number): void {
        for (var i = this.invoiceDetails.length - 1; i >= 0; i--) {
            if (this.invoiceDetails[i].id === id) {
                this.invoiceDetails.splice(i, 1);
            }
        }
        this.invoiceService.deleteInvoiceDetails(id).subscribe((response: any) => {
            this.translate.get(response.message).subscribe(t => {
                this.alertService.success(t);
            });
        });

        if(this.selectedInvoice) {
          if(this.selectedInvoice.id == id) {
            this.onChangeInvoice.emit(null);
          }
        }
    }

    public addNewDetails(): void {
        this.invoiceDetailsForm.reset();
        this.display = true;
        this.isEditing = false;
        this.invoiceDetailsForm.get('invoice_type').setValue(2);
        this.invoiceDetailsForm.get('country').setValue('PL');
        this.onInvoiceTypeChange({value: 2});
    }

    public onSelectInvoice(invoice: InvoiceDetails): void {
        this.onChangeInvoice.next(invoice);
        this.selectedInvoice = invoice;
    }

    public onEditDetails(id: number): void {
        this.invoiceDetailsForm.reset();
        this.isEditing = true;
        for (var i = this.invoiceDetails.length - 1; i >= 0; i--) {
            if (this.invoiceDetails[i].id === id) {
              const pachVal: InvoiceDetails = {
                apartment_number: this.invoiceDetails[i].apartment_number,
                city: this.invoiceDetails[i].city,
                country: this.invoiceDetails[i].country,
                id: this.invoiceDetails[i].id,
                invoice_type: this.invoiceDetails[i].invoice_type,
                is_gus_data: this.invoiceDetails[i].is_gus_data,
                name: this.invoiceDetails[i].name,
                postal_code: this.invoiceDetails[i].postal_code,
                street: this.invoiceDetails[i].street,
                street_number: this.invoiceDetails[i].street_number,
                surname: this.invoiceDetails[i].surname,
                tax_number: this.invoiceDetails[i].tax_number,
              };
              this.invoiceDetailsForm.patchValue(pachVal);

              const recipientPatchVal = {
                recipient_city: this.invoiceDetails[i].recipient_city,
                recipient_name: this.invoiceDetails[i].recipient_name,
                recipient_postal_code: this.invoiceDetails[i].recipient_postal_code,
                recipient_street: this.invoiceDetails[i].recipient_street,
                recipient_street_number: this.invoiceDetails[i].recipient_street_number,
              };
              this.recipientForm.patchValue(recipientPatchVal);

              this.onInvoiceTypeChange({value: this.invoiceDetails[i].invoice_type});
            }
        }
        this.display = true;
    }

    public onSubmit(): void {
      let id: number = this.invoiceDetailsForm.controls['id'].value;
      let obj: InvoiceDetails;

      if (this.isEditing == true) {
        if (this.recipientForm.valid) {
          obj = {
            ...this.invoiceDetailsForm.value,
            ...this.recipientForm.value
          };
        } else {
          obj = {
            ...this.invoiceDetailsForm.value,
          };
        }

        this.invoiceService.updateInvoiceDetails(obj).subscribe((response: any) => {
            this.translate.get(response.message).subscribe(t => {
                this.alertService.success(t);
            });
            for (var i = this.invoiceDetails.length - 1; i >= 0; i--) {
                if (this.invoiceDetails[i].id === id) {
                    this.invoiceDetails[i] = response.data.invoice_details;
                }
            }
        });
      } else {
        if (this.recipientForm.valid) {
          obj = {
            ...this.invoiceDetailsForm.value,
            ...this.recipientForm.value
          };
        } else {
          obj = {
            ...this.invoiceDetailsForm.value,
          };
        }

        this.invoiceService.addInvoiceDetails(obj).subscribe((response: any) => {
            this.translate.get(response.message).subscribe(t => {
                this.alertService.success(t);
            });
            this.invoiceDetails.push(response.data.invoice_details);
        });
      }
      this.display = false;
      this.invoiceDetailsForm.reset();
      this.recipientForm.reset();
    }

    public cancelForm(): void {
        this.display = false;
        this.invoiceDetailsForm.reset();
    }

    public onLoadGusDataDialog() {
      this.gusDialogVisible = true;
    }

    public loadGusData() {
      this.gusDataLoading = true;
      const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
      const nip = this.gusTaxNumber.replace(/[\s-]/g, '');

      if (nip.length === 10 && parseInt(nip, 10) > 0) {
        let sum = 0;
        for (let i = 0; i < 9; i++) {
          sum += parseInt(nip[i]) * weights[i];
        }
        this.isNipValid = (sum % 11) === Number(nip[9]);
      } else {
        this.isNipValid = false;
      }

      if (this.isNipValid) {
        this.gusService.loadGusData({nip: nip}).subscribe(response => {
          console.log(response);
          if (response.success && response.data.length > 0) {
            this.invoiceDetailsForm.controls['name'].setValue(response.data[0].name);
            this.invoiceDetailsForm.controls['tax_number'].setValue(nip);
           // this.invoiceDetailsForm.controls['country'].setValue(response.data[0].country);
            this.invoiceDetailsForm.controls['city'].setValue(response.data[0].city);
            this.invoiceDetailsForm.controls['postal_code'].setValue(response.data[0].postalCode);
            this.invoiceDetailsForm.controls['street'].setValue(response.data[0].street);
            this.invoiceDetailsForm.controls['street_number'].setValue(response.data[0].streetNo);
            this.invoiceDetailsForm.controls['apartment_number'].setValue(response.data[0].apartmentNo);
            this.invoiceDetailsForm.get("is_gus_data").setValue(true);
          }

          this.gusDataLoading = false;
          this.gusDialogVisible = false;
        });
      } else {
        this.gusDataLoading = false;
      }
    }

    showRecipientForm() {
      this.recipientFormVisible = true;
    }

    cancelRecipientForm() {
      this.recipientFormVisible = false;
      this.recipientForm.reset();
    }

    recipientFormSubmit() {
      this.recipientFormVisible = false;
    }
}
